import React from 'react';
import { Icon } from './Icon.js';
export const IconCurveFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M2.75,15.5c-.414,0-.75-.336-.75-.75s.336-.75,.75-.75c4.058,0,4.707-2.296,5.528-5.204,.834-2.951,1.779-6.296,6.972-6.296,.414,0,.75,.336,.75,.75s-.336,.75-.75,.75c-4.058,0-4.707,2.296-5.528,5.204-.834,2.951-1.779,6.296-6.972,6.296Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCurveFill18.js.map